module.exports = __webpack_public_path__ + "static/media/settings-screen.9191cca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings-screen.jpg
// module id = 1154
// module chunks = 0